// extracted by mini-css-extract-plugin
module.exports = {"option":"select_option__13q08","selected":"select_selected__2iPoK"};